import React from "react";
import Stack from "@vapor/react-material/Stack";
import Button from "@vapor/react-material/Button";
import {
  Check as CheckIcon,
  CloseOutlined as CancelIcon,
} from "@mui/icons-material";

export const ImportToolbarActions = ({
  t,
  selectedCount,
  onCancel,
  onConfirmImport,
}) => {
  return (
    <Stack direction="row" spacing={2}>
      <Button
        variant="outlined"
        color="secondary"
        size="medium"
        endIcon={<CancelIcon />}
        onClick={onCancel}
        disabled={selectedCount <= 0}
      >
        {t("actions.annulla")}
      </Button>
      <Button
        variant="contained"
        size="medium"
        endIcon={<CheckIcon />}
        onClick={onConfirmImport}
        disabled={selectedCount <= 0}
      >
        {t("anagrafica.ImportDesktop.confAndImp")}
      </Button>
    </Stack>
  );
};
